export default __webpack_public_path__ + "static/media/filter_status_blue.65ba8dac.svg";